import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-observation-focus-area-indicator',
    templateUrl: './observation-focus-area-indicator.component.html',
    styleUrls: ['./observation-focus-area-indicator.component.scss']
})
export class ObservationFocusAreaIndicatorComponent implements OnInit {
    @Input() isFocusArea?: boolean = false;
    @Input() readonly?: boolean = false;

    @Output() onClickFocus = new EventEmitter<boolean>();

    constructor() { }

    ngOnInit(): void {
    }

    onClickFocusArea() {
        if (this.readonly) return;
        this.isFocusArea = !this.isFocusArea;
        this.onClickFocus.emit(this.isFocusArea);
    }
}
